import { render, staticRenderFns } from "./SolicitudCompleta.vue?vue&type=template&id=68a2eea5"
import script from "./SolicitudCompleta.vue?vue&type=script&lang=js"
export * from "./SolicitudCompleta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports